import { BlockRecycleBin } from "models/block/blocks/top-level-scopes/recycle-bin";
export const blockRecycleBin = new BlockRecycleBin();
